import evocacoes from "@/assets/evocacoes-arte-performatica.jpg.asset.json";

export type ClipItem = {
  outlet: string;
  title: string;
  url: string;
  kind: "TV & Video" | "Press" | "Academic" | "Institutional";
};

export const clippingImages: string[] = [
  "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b3560bb1-78d7-41e8-ae6f-400963fa2f27/digital+photographer+luiza+prado+2.jpg",
  "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/a1396115-434a-4e6f-b268-4b980728e6a6/469743183_18477145222010496_5228301218259351113_n.jpg",
  "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/532fe81e-cf04-4cfb-82e7-88edbe6ab521/465241316_28216115554654424_7441621715046126574_n.jpg",
  "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9243fe0b-62fe-4e60-ba88-9e62ee8100cc/465604993_28245539515045361_4374380478597925147_n.jpg",
  "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/12496845-92c5-4eea-bd0b-abe9ae98ff2a/464906702_28178164431782870_4164890139774026616_n.jpg",
  "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0015c24d-1276-40c9-aab8-204e241a01c0/464708395_28167383286194318_7410113952212154664_n.jpg",
  evocacoes.url,
];

export const clipping: ClipItem[] = [
  {
    outlet: "Globoplay",
    title: "A Intervenção do Olhar — série",
    url: "https://globoplay.globo.com/v/8698878/",
    kind: "TV & Video",
  },
  {
    outlet: "Canal Brasil / Xplastic",
    title: "Fotografia dramática & catártica de Luiza Prado",
    url: "https://xplastic.com.br/blog/luiza-prado-fotografia-framatica-e-catartica-de-luiza/",
    kind: "TV & Video",
  },
  {
    outlet: "TV Band",
    title: "A Liga",
    url: "https://www.youtube.com/watch?v=1WlwlCmqsDk",
    kind: "TV & Video",
  },
  {
    outlet: "MAC Bogotá",
    title: "Art en Cuarentena",
    url: "https://www.youtube.com/watch?v=LXjqChQAVqk",
    kind: "TV & Video",
  },
  {
    outlet: "ArtsSP",
    title: "ArtsSP 3ªEdição #AArteTransforma. EP 4 Processo Criativo – HIFA CYBE",
    url: "https://www.youtube.com/watch?v=tEgT6L8CZDo&t=75s",
    kind: "TV & Video",
  },
  {
    outlet: "Retomada",
    title: "Quem é o necrófilo? A artista que ofereceu o próprio corpo ao Estado para discutir quem manda nos nossos corpos",
    url: "https://retomadamidia.wordpress.com/2026/10/30/quem-e-o-necrofilo-arte-politica-luiza-jesus-do-prado/",
    kind: "Press",
  },
  {
    outlet: "EXPLOIT",
    title: "Every System Has a Seam: Ten Brazilian Artists Hacking Technology",
    url: "https://exploit50.wordpress.com/2026/10/30/brazilian-artists-hacking-technology/",
    kind: "Press",
  },
  {
    kind: "Press",
    outlet: "Gazeta da Semana",
    title: "Arts SP: projeções inéditas unem arte urbana, rock e blues na Avenida Paulista",
    url: "https://gazetadasemana.com.br/noticia/228099/arts-sp-projecoes-ineditas-unem-arte-urbana-rock-e-blues-na-avenida-paulista",
  },
  {
    outlet: "Tab UOL",
    title: "Em performance póstuma, artista quer doar o corpo para necrofilia",
    url: "https://tab.uol.com.br/noticias/redacao/2020/10/16/em-performance-de-arte-postuma-artista-quer-doar-o-corpo-para-necrofilia.htm",
    kind: "Press",
  },
  {
    outlet: "Revista Perro Negro",
    title: "Seven questions to Brazilian artist Luiza Prado",
    url: "http://revistaperronegro.com/seven-questions-to-brazilian-artist-luiza-prado/",
    kind: "Press",
  },
  {
    outlet: "iPhoto Channel",
    title: "A sua foto de 2013",
    url: "https://iphotochannel.com.br/sua-foto-de-2013-luiza-prado/",
    kind: "Press",
  },
  {
    outlet: "Pahnorama",
    title: "Década dos Oceanos — CCBB RJ, 1ª Mostra Nacional de Criptoarte",
    url: "https://pahnorama.com.br/2024/01/17/d%c3%a9cada-dos-oceanos-ccbb-rj-recebe-a-vanguarda-digital-na-1%c2%aa-mostra-nacional-de-criptoarte/",
    kind: "Press",
  },
  {
    outlet: "Cosmoscow Foundation",
    title: "Pre-auction exhibition ‘Architectures of Dream’, Eliseevsky",
    url: "https://www.cosmoscow.com/en/news/149/",
    kind: "Press",
  },
  {
    outlet: "Shibari Atlas",
    title: "Shibari Experience Brazil 2025",
    url: "https://shibariatlas.org/events/2025/shibari-experience-brazil-2025/",
    kind: "Press",
  },
  {
    outlet: "ANBA",
    title: "Cairo Biennale features work by six Brazilians",
    url: "https://anba.com.br/en/cairo-biennale-features-work-by-six-brazilians/",
    kind: "Press",
  },
  {
    outlet: "Artda",
    title: "2nd Changjiang International Photo & Video Biennale",
    url: "https://www.artda.cn/guoneixinwen-c-10458.html",
    kind: "Press",
  },
  {
    outlet: "MEON",
    title: "Artista da região provoca e protesta com nudez em fotografias",
    url: "https://www.meon.com.br/noticias/meon/cultura/artista-da-regiao-provoca-e-protesta-com-nudez-em-fotografias",
    kind: "Press",
  },
  {
    outlet: "Paco Editorial",
    title: "Livro — Evocações da Arte Performática (2010–2013)",
    url: "https://www.amazon.com.br/Evoca%C3%A7%C3%B5es-Perform%C3%A1tica-2010-2013-Paulo-Aureliano/dp/8546202532",
    kind: "Academic",
  },
  {
    outlet: "Sexuality Policy Watch",
    title: "Luiza Prado: Memories of Violence",
    url: "https://sxpolitics.org/we-recommend/sexuality-art/luiza-prado-memories-of-violence/14843/",
    kind: "Academic",
  },
  {
    outlet: "UFG — Érica Saraiva",
    title: "Cultura do estupro e performance na obra de Luiza Prado",
    url: "https://files.cercomp.ufg.br/weby/up/778/o/CulturaVisual_L1_051.pdf",
    kind: "Academic",
  },
  {
    outlet: "UFG — Érica Cristiane Saraiva",
    title: "Visualidades de Luiza Prado: poética da ex-centricidade",
    url: "https://files.cercomp.ufg.br/weby/up/459/o/Disserta%C3%A7%C3%A3o_-_Erica_Cristiane_Saraiva_-_2017.pdf",
    kind: "Academic",
  },
  {
    outlet: "Wikipedia BR",
    title: "Luiza Prado",
    url: "https://pt.wikipedia.org/wiki/Luiza_Prado",
    kind: "Institutional",
  },
  {
    outlet: "Arteinformado",
    title: "Perfil — Luiza Prado",
    url: "https://www.arteinformado.com/guia/f/luiza-prado-175696",
    kind: "Institutional",
  },
  {
    outlet: "MAC Bogotá",
    title: "Cuerpos Políticos",
    url: "https://www.arteinformado.com/agenda/f/cuerpos-politicos-172212",
    kind: "Institutional",
  },
  {
    outlet: "MAC Bogotá",
    title: "Dinamismo",
    url: "https://www.arteinformado.com/agenda/f/dinamismo-154455",
    kind: "Institutional",
  },
  {
    outlet: "MAC Bogotá",
    title: "Medusas Mujer-Mito / Mujer-Sombra",
    url: "https://www.arteinformado.com/agenda/f/medusas-mujer-mito-mujer-sombra-127117",
    kind: "Institutional",
  },
  {
    outlet: "IMDb",
    title: "Luiza Jesus do Prado",
    url: "https://www.imdb.com/name/nm19005373/?ref_=pro_nmovr_ov_visitcons",
    kind: "Institutional",
  },
  {
    outlet: "IMDbPro",
    title: "Luiza Jesus do Prado",
    url: "https://pro.imdb.com/name/nm19005373/",
    kind: "Institutional",
  },
  {
    outlet: "MUBI",
    title: "Luiza Jesus do Prado — Filmes, Biografia e Listas",
    url: "https://mubi.com/pt/cast/luiza-jesus-do-prado",
    kind: "Institutional",
  },
];

export const clippingSections = [
  "TV & Video",
  "Press",
  "Academic",
  "Institutional",
] as const;
